import script from "./employee-salary.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-salary.vue?vue&type=script&setup=true&lang=js"

import "./employee-salary.vue?vue&type=style&index=0&id=3554f25a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3554f25a"]])

export default __exports__